// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CurrencyMinor from "../../../../../../library/data-source/country-currency/CurrencyMinor.bs.js";
import * as CorePricingStatus from "../entity/CorePricingStatus.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as CorePricingApiModel from "../api-model/CorePricingApiModel.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";

function getBaseCampaign(campaign, campaign_type) {
  var time = campaign.status.approval_time;
  var approver = campaign.status.approver;
  return {
          campaign_name: campaign.name,
          campaign_id: campaign.external_id,
          status: campaign_type,
          start_date: Timestamp$Catalyst.make(campaign.start_instant),
          fare_details: {
            base_fare: CurrencyMinor.toBase(campaign.core_pricing_structure.base_fare.minor_amount),
            free_duration: campaign.core_pricing_structure.free_duration,
            waiting_rate_per_min: CurrencyMinor.toBase(campaign.core_pricing_structure.waiting_rate_per_min.minor_amount),
            free_slab: {
              free_kms: campaign.core_pricing_structure.free_distance_pricing.free_kms,
              price_per_min: CurrencyMinor.toBase(campaign.core_pricing_structure.free_distance_pricing.price_per_min.minor_amount)
            }
          },
          slabs: List.map((function (slab) {
                  return {
                          slab_km: slab.slab_km,
                          price_per_min: CurrencyMinor.toBase(slab.price_per_min.minor_amount),
                          price_per_km: CurrencyMinor.toBase(slab.price_per_km.minor_amount)
                        };
                }), campaign.core_pricing_structure.distance_time_pricing),
          created_on: Timestamp$Catalyst.make(campaign.creation_info.creation_time),
          created_by: campaign.creation_info.creator.first_name + (" " + campaign.creation_info.creator.last_name),
          approved_on: time !== undefined ? Caml_option.some(Timestamp$Catalyst.make(time)) : undefined,
          approved_by: approver !== undefined ? approver.first_name + " " + approver.last_name : undefined
        };
}

function execute(json) {
  var model = DeccoUtils$Catalyst.resolveResult(CorePricingApiModel.t_decode(json), "CorePricingEntityMapper.re");
  return List.map((function (campaign) {
                var campaign_type = CorePricingStatus.fromString(campaign.status.campaign_status);
                switch (campaign_type) {
                  case /* Pending */0 :
                      return {
                              TAG: /* Pending */1,
                              _0: getBaseCampaign(campaign, campaign_type)
                            };
                  case /* Scheduled */1 :
                      return {
                              TAG: /* Scheduled */0,
                              campaign: getBaseCampaign(campaign, campaign_type),
                              end_date: Belt_Option.mapWithDefault(campaign.end_instant, undefined, (function (d) {
                                      return Caml_option.some(Timestamp$Catalyst.make(d));
                                    }))
                            };
                  case /* Rejected */2 :
                      return {
                              TAG: /* Rejected */2,
                              _0: getBaseCampaign(campaign, campaign_type)
                            };
                  case /* Deleted */3 :
                      return {
                              TAG: /* Deleted */3,
                              campaign: getBaseCampaign(campaign, campaign_type),
                              end_date: Belt_Option.mapWithDefault(campaign.end_instant, undefined, (function (d) {
                                      return Caml_option.some(Timestamp$Catalyst.make(d));
                                    }))
                            };
                  
                }
              }), model.campaigns);
}

export {
  execute ,
  
}
/* Timestamp-Catalyst Not a pure module */
